import { render, staticRenderFns } from "./Gheibat.vue?vue&type=template&id=73bde4ac&scoped=true"
import script from "./Gheibat.vue?vue&type=script&lang=js"
export * from "./Gheibat.vue?vue&type=script&lang=js"
import style0 from "./Gheibat.vue?vue&type=style&index=0&id=73bde4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bde4ac",
  null
  
)

export default component.exports